import { ReactNode } from 'react';
import { Container, Flex } from '@chakra-ui/react';
import { Header } from './header/Header';
import { Footer } from './footer/Footer';
import { Page } from './page/Page';

export type LayoutProps = {
  children?: ReactNode;
};

export const Layout = ({ children }: LayoutProps): JSX.Element => (
  <Flex direction="column" h="100vh">
    <Header />
    <Container px={4} py={6} display="flex" justifyContent="center" flex={1}>
      <Page
        flexGrow={1}
        noSidebar={[
          '/login',
          '/login/not-registered',
          '/confirmation',
          '/recover',
          '/check-deposit',
          '/contactus',
        ]}
      >
        {children}
      </Page>
    </Container>
    <Footer />
  </Flex>
);
